import { formatDayMonthYear, todayIso } from '../../../../utils/date-only';
import { OrderPhoto } from '../../orders-new/models/order.dto';
import { ClientOrderListItemDto, ClientOrderStatus } from './client-order-list-item.dto';

export interface ClientOrderRowVm {
  id: number;
  orderNumber: string;
  clientName: string;
  name: string | null;
  createdAtLabel: string;
  deadlineLabel: string | null;
  statusLabel: string;
  /**
   * "1/2" — positions covered in full out of all positions, for zlecenia and for wysyłki.
   */
  allocatedLabel: string;
  shippedLabel: string;
  /**
   * The promise is in the past and the goods have not all left — the row that needs a look.
   */
  overdue: boolean;
  /** The zamówienie's faces (0082); the row shows the first, a click flips to the next (0085), a blank slot when empty. */
  photos: OrderPhoto[];
}

// the five states of a zamówienie, as the list and the detail name them
export const CLIENT_ORDER_STATUS_LABELS: Record<ClientOrderStatus, string> = {
  [ClientOrderStatus.new]: 'Nowe',
  [ClientOrderStatus.confirmed]: 'Potwierdzone',
  [ClientOrderStatus.inProduction]: 'W produkcji',
  [ClientOrderStatus.partiallyShipped]: 'Częściowo wysłane',
  [ClientOrderStatus.shipped]: 'Wysłane'
};

export namespace ClientOrderRowVm {
  export function mapModelToViewModel(order: ClientOrderListItemDto): ClientOrderRowVm {
    return {
      id: order.id,
      orderNumber: order.orderNumber,
      clientName: order.clientName,
      name: order.name,
      // CreatedAt is a UTC timestamp — the date part is enough for the list
      createdAtLabel: formatDayMonthYear(order.createdAt.slice(0, 10)),
      deadlineLabel: order.deadline ? formatDayMonthYear(order.deadline) : null,
      statusLabel: CLIENT_ORDER_STATUS_LABELS[order.status],
      allocatedLabel: `${order.positionsAllocated}/${order.positionCount}`,
      shippedLabel: `${order.positionsShipped}/${order.positionCount}`,
      // ISO day strings compare as dates
      overdue: order.deadline !== null && order.deadline < todayIso() && order.status !== ClientOrderStatus.shipped,
      photos: order.photos
    };
  }
}
